function _first(arr) {
  return arr[0];
}

function _flatten(arrayOfArrays) {
  return [].concat.apply([], arrayOfArrays);
}

function _last(arr) {
  return arr[arr.length - 1];
}


function _unique(arr, callback) {
  const uniqueArr = [];

  return arr.filter(el => {
    const uniqueValue = callback ? callback(el) : el;
    const isUnique = uniqueArr.indexOf(uniqueValue) === -1;

    if (isUnique) {
      uniqueArr.push(uniqueValue);
    }

    return isUnique;
  });
}

function _union(arr1, arr2) {
  return _unique([...arr1, ...arr2]);
}

function _values(obj) {
  return Object.keys(obj).map((key) => obj[key]);
}

function* _zip(arrays) {
  const iterators = arrays.map(a => a[Symbol.iterator]());
  while (true) {
    const results = iterators.map(it => it.next());
    if (results.some(r => r.done)) return;
    yield results.map(r => r.value);
  }
}

export {
  _first,
  _flatten,
  _last,
  _unique,
  _union,
  _values,
  _zip,
};
